import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";
import { TIMES, fmtDay, rangeDays } from "./rules";

const inp = "rounded-sm border border-stone-300 bg-white px-2 py-1.5 text-sm";

const TimeSelect = ({ value, onChange, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={inp} data-testid={testId}>
    {TIMES.map((t) => <option key={t} value={t}>{t}</option>)}
  </select>
);

const KindPicker = ({ kind, setKind }) => (
  <div className="flex flex-wrap gap-2">
    {[["closed", "Can't cover - not available"], ["extra", "Can cover - open these hours"]].map(([k, l]) => (
      <button key={k} type="button" onClick={() => setKind(k)} data-testid={`quick-kind-${k}`}
        className={`px-3 py-1.5 rounded-full border text-sm ${kind === k ? (k === "closed" ? "bg-red-700 text-white border-red-700" : "bg-amber-600 text-white border-amber-600") : "border-stone-300"}`}>{l}</button>
    ))}
  </div>
);

export const QuickEntry = ({ pickedDay, onAdd }) => {
  const [kind, setKind] = useState("closed");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [times, setTimes] = useState({ from: "17:30", until: "19:30" });
  const [weekdaysOnly, setWeekdaysOnly] = useState(false);

  useEffect(() => { if (pickedDay) { setFrom(pickedDay); setTo(""); } }, [pickedDay]);

  const add = () => {
    if (!from) return toast.error("Please type or pick a start date.");
    if (to && to < from) return toast.error("The end date is before the start date.");
    if (kind === "extra" && times.until <= times.from) return toast.error("The finish time must be after the start time.");
    const days = rangeDays(from, to, weekdaysOnly);
    if (!days.length) return toast.error("No days in that range - untick 'weekdays only'?");
    onAdd(kind, { from, to: to || from, days, start: times.from, until: times.until });
    toast.success(`${kind === "closed" ? "Marked not available" : "Opened"}: ${fmtDay(from)}${to && to !== from ? ` to ${fmtDay(to)}` : ""} - remember to save`);
    setTo("");
  };

  return (
    <div data-testid="quick-entry" className="p-5 bg-cream-100 border border-bronze-light/40 rounded-md space-y-4">
      <div className="font-serif text-xl">Add dates</div>
      <KindPicker kind={kind} setKind={setKind} />
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs text-ink-muted">From<br /><input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={inp} data-testid="quick-from" /></label>
        <label className="text-xs text-ink-muted">To (optional)<br /><input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} className={inp} data-testid="quick-to" /></label>
        {kind === "extra" && (
          <label className="text-xs text-ink-muted">Hours (UK time)<br />
            <span className="inline-flex items-center gap-1.5"><TimeSelect value={times.from} onChange={(v) => setTimes((t) => ({ ...t, from: v }))} testId="quick-time-from" />–
              <TimeSelect value={times.until} onChange={(v) => setTimes((t) => ({ ...t, until: v }))} testId="quick-time-until" /></span>
          </label>
        )}
      </div>
      {kind === "extra" && to && to !== from && (
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={weekdaysOnly} onChange={(e) => setWeekdaysOnly(e.target.checked)} data-testid="quick-weekdays-only" /> Weekdays only (skip Saturdays and Sundays)</label>
      )}
      <button type="button" onClick={add} data-testid="quick-add-btn" className="btn-secondary inline-flex items-center gap-1.5"><Plus size={14} /> Add to calendar</button>
      <p className="text-xs text-ink-muted">Tip: click a day in the calendar to fill in the date.</p>
    </div>
  );
};
